// In-memory ring buffer of the last N dispatched Redux actions, read by the
// crash report to answer "what was the user doing before it broke?". Route
// changes are dispatched as "@@router/LOCATION_CHANGE" by a history listener
// in app.js, so navigations are captured too. Kept out of the store on purpose: it must survive a crash
// mid-dispatch and carries no reducer/persistence weight.
const MAX = 10;
const trail = [];

export const breadcrumbMiddleware = () => (next) => (action) => {
  trail.push({ type: action.type, ts: new Date().toISOString() });
  if (trail.length > MAX) trail.shift();
  return next(action);
};

export const getBreadcrumbs = () => trail.slice();
